var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-green fs-12 d-flex mb-15 mt-15"},[_c('i-info',{staticClass:"icon my-auto mr-10 flex-none"}),_c('span',{staticClass:"my-auto"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }